<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    id="milestone-jet"
    width="280"
    height="550"
    class="intro"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -50 207.8 459.1"
    role="presentation"
    aria-labelledby="netlifylaunch"
  >
    <title id="netlifylaunch">Launch of Netlify!</title>
    <g class="computer-jet">
      <g>
        <g>
          <path
            class="a"
            d="M201.4,242.4l-107-61.6a3,3,0,0,0-2.4-.4h0l-3.8,2.1,3,4.3v91c0,2.9,1.8,6.3,4,7.5l104.5,64h.2l1.3-.5,2.2-1.2.5-.3a3.8,3.8,0,0,0,1.4-3.3l.2-94C205.4,247.1,203.6,243.7,201.4,242.4Z"
            transform="translate(-0.1 -0.3)"
          />
          <g>
            <path
              class="b"
              d="M198.5,348.8,91.4,287.1c-2.1-1.2-3.8-4.4-3.8-7.2V185.5c0-2.8,1.7-4,3.7-2.8l107.1,61.7c2.1,1.2,3.8,4.4,3.8,7.2v91.6C202.3,345.9,200.6,350,198.5,348.8Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M199.3,349.4a1.9,1.9,0,0,1-1-.3L91.2,287.4c-2.2-1.3-4-4.7-4-7.6V185.4a3.8,3.8,0,0,1,1.5-3.4,2.8,2.8,0,0,1,2.9.2l107.1,61.7c2.2,1.3,4,4.7,4,7.6v91.6c0,2.2-1,5.1-2.5,6A1.6,1.6,0,0,1,199.3,349.4ZM89.9,182.7l-.7.2a2.9,2.9,0,0,0-1.1,2.6v94.4c0,2.6,1.6,5.7,3.5,6.8l107.1,61.7a.9.9,0,0,0,1,0c1.2-.7,2.1-3.3,2.1-5.2V251.6c0-2.6-1.6-5.7-3.5-6.8L91.2,183Z"
              transform="translate(-0.1 -0.3)"
            />
          </g>
          <g>
            <path
              class="c"
              d="M195.9,339,94,280.3a3.9,3.9,0,0,1-1.7-3.2v-85c0-1.2.7-1.8,1.7-1.3l101.9,58.7a3.9,3.9,0,0,1,1.7,3.2v85C197.6,339,196.8,339.5,195.9,339Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M196.6,339.6a1.6,1.6,0,0,1-.9-.3L93.8,280.7a4.4,4.4,0,0,1-1.9-3.6v-85a1.9,1.9,0,0,1,.8-1.7,1.4,1.4,0,0,1,1.5.1L196,249.2a4.4,4.4,0,0,1,1.9,3.6v85a1.9,1.9,0,0,1-.8,1.7Zm-.5-1a.6.6,0,0,0,.6.1c.2-.1.3-.5.3-1v-85a3.8,3.8,0,0,0-1.4-2.8L93.7,191.2a.6.6,0,0,0-.6-.1c-.2.1-.3.5-.3,1v85a3.8,3.8,0,0,0,1.4,2.8Z"
              transform="translate(-0.1 -0.3)"
            />
          </g>
          <path
            class="a"
            d="M145.3,215.3l-.4-.2a1.1,1.1,0,0,0-1.1,0,1.2,1.2,0,0,0-.6,1.2,2.6,2.6,0,0,0,1.2,2.2l.4.2.6.2h.5a1.2,1.2,0,0,0,.6-1.2A2.5,2.5,0,0,0,145.3,215.3Z"
            transform="translate(-0.1 -0.3)"
          />
          <path
            class="a"
            d="M191.8,347.5,89.5,288.6c-2.2-1.3-6-1.1-8.5.3L6.5,332l-4.3-.4v3.2h.2a3.6,3.6,0,0,0,1.5,2.5L111,399a7.2,7.2,0,0,0,3.7.9,9.8,9.8,0,0,0,4.8-1.2l76.7-41.8a3.7,3.7,0,0,0,2.2-3v-6Z"
            transform="translate(-0.1 -0.3)"
          />
          <path
            class="b"
            d="M111,395.8,3.9,334.2c-2.1-1.2-1.8-3.3.6-4.7l76.7-44.4a8.9,8.9,0,0,1,8.1-.3l107.1,61.7c2.1,1.2,1.8,3.3-.6,4.7l-76.7,44.4A9.2,9.2,0,0,1,111,395.8Z"
            transform="translate(-0.1 -0.3)"
          />
          <path
            class="c"
            d="M89.4,286.7c-2.1-1.2-5.7-1-8.1.3L4.6,331.4a3.7,3.7,0,0,0-1.8,2A2.8,2.8,0,0,0,4,334.6l107.1,61.7c2.1,1.2,5.7,1,8.1-.3l76.7-44.4a3.7,3.7,0,0,0,1.8-2,2.8,2.8,0,0,0-1.2-1.2Z"
            transform="translate(-0.1 -0.3)"
          />
          <g>
            <path
              class="b"
              d="M141.8,375.1l-102-58.7c-.9-.5-.8-1.5.3-2.1l42.8-24.8a4.2,4.2,0,0,1,3.6-.2L188.4,348c.9.5.8,1.5-.3,2.1l-42.8,24.8A4,4,0,0,1,141.8,375.1Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M143.3,375.9a3.4,3.4,0,0,1-1.8-.4L39.6,316.7a1.6,1.6,0,0,1-.8-1.3,1.9,1.9,0,0,1,1.1-1.6L82.7,289a4.4,4.4,0,0,1,4-.2l101.9,58.7a1.6,1.6,0,0,1,.8,1.3,1.9,1.9,0,0,1-1.1,1.6l-42.8,24.8A3.4,3.4,0,0,1,143.3,375.9Zm-1.3-1.2a3.4,3.4,0,0,0,3.1-.2l42.8-24.8c.4-.2.7-.5.7-.8a.7.7,0,0,0-.4-.5L86.3,289.7a3.4,3.4,0,0,0-3.1.2L40.3,314.7c-.4.2-.7.5-.7.8a.7.7,0,0,0,.4.5Z"
              transform="translate(-0.1 -0.3)"
            />
          </g>
          <g>
            <path
              class="b"
              d="M75.8,370.6,47.6,354.3c-.5-.3-.4-.8.1-1.1l22.8-13.3a2.1,2.1,0,0,1,1.9-.1l28.2,16.3c.5.3.4.8-.1,1.1L77.7,370.5A1.9,1.9,0,0,1,75.8,370.6Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M76.6,371.3l-1.1-.2L47.3,354.8a1,1,0,0,1-.6-.9,1.2,1.2,0,0,1,.7-1l22.8-13.3a2.9,2.9,0,0,1,2.4-.1l28.2,16.3a1,1,0,0,1,.6.9,1,1,0,0,1-.7,1L77.9,371A2.5,2.5,0,0,1,76.6,371.3Zm-5-31.1-.9.2L47.9,353.7l-.2.2h.1L76,370.3a1.6,1.6,0,0,0,1.5-.1l22.8-13.3c.2-.1.2-.2.2-.2h-.1L72.2,340.3Z"
              transform="translate(-0.1 -0.3)"
            />
          </g>
          <path
            class="a"
            d="M188.7,347.6,86.8,288.9a4.4,4.4,0,0,0-4,.2L39.9,313.9a1.9,1.9,0,0,0-1.1,1.6,1.6,1.6,0,0,0,.8,1.3l.7.4,42.8-24.8a3.8,3.8,0,0,1,3.1-.2l101.4,58.4h.2l.5-.3a1.9,1.9,0,0,0,1.1-1.6A1.2,1.2,0,0,0,188.7,347.6Z"
            transform="translate(-0.1 -0.3)"
          />
          <path
            class="a"
            d="M100.9,355.8,72.7,339.5a2.6,2.6,0,0,0-2.4.1L47.5,352.9c-.4.3-.7.6-.7,1a1.1,1.1,0,0,0,.6.9l1,.6,22.4-13a2,2,0,0,1,1.5-.1l27.4,15.8h.2l.9-.5c.4-.3.7-.6.7-1A1,1,0,0,0,100.9,355.8Z"
            transform="translate(-0.1 -0.3)"
          />
          <path
            class="a"
            d="M77.1,371.5a2.4,2.4,0,0,1-1.4-.5L49.1,355.7c-.4-.2-.8-.4-.7-.8a.7.7,0,0,1,.4-.6l5.5-3.2c.4-.2,1.2.2,1.5.3l26.4,15.2c.9.5.9.8.9,1v.3l-.3.2-5.5,3.3C77.3,371.5,77.2,371.5,77.1,371.5ZM49.5,355h.2l26.5,15.2.9.3,5-3h-.2L55.5,352.3l-.7-.3Z"
            transform="translate(-0.1 -0.3)"
          />
          <g>
            <path
              class="a"
              d="M80.3,298.3l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1L84.9,295a3.8,3.8,0,0,0-3.3.1l-1.2.7a1.5,1.5,0,0,0-.9,1.3A2,2,0,0,0,80.3,298.3Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M86.8,301.3a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A1.9,1.9,0,0,0,86.8,301.3Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M93.9,305.4a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A1.9,1.9,0,0,0,93.9,305.4Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M101,309.5a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A1.9,1.9,0,0,0,101,309.5Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M108.1,313.6a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A2.3,2.3,0,0,0,108.1,313.6Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M115.3,317.7a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A2.1,2.1,0,0,0,115.3,317.7Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M122.4,321.8a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A2.1,2.1,0,0,0,122.4,321.8Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M129.5,325.9a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7C129.9,325,129.5,325.4,129.5,325.9Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M136.7,330a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A2.1,2.1,0,0,0,136.7,330Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M143.8,334.1a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A2.3,2.3,0,0,0,143.8,334.1Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M151.1,338.4a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A2.3,2.3,0,0,0,151.1,338.4Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M158.3,342.5a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A1.9,1.9,0,0,0,158.3,342.5Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M165.4,346.6a1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7A1.9,1.9,0,0,0,165.4,346.6Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M180.7,350.2l-2.9-1.6a3.8,3.8,0,0,0-3.3.1l-1.2.7a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l2.9,1.6a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l1.2-.7a1.5,1.5,0,0,0,.9-1.3C181.4,350.9,181.2,350.5,180.7,350.2Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M72,303l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.4,1.4,0,0,0,72,303Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M89.1,304.3l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C89.8,305,89.5,304.6,89.1,304.3Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M96.3,308.5l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C97,309.1,96.7,308.8,96.3,308.5Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M103.4,312.6l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C104.1,313.2,103.8,312.9,103.4,312.6Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M110.5,316.7l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C111.2,317.4,111,317,110.5,316.7Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M117.7,320.8l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C118.4,321.5,118.2,321.1,117.7,320.8Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M124.8,325l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C125.6,325.6,125.3,325.2,124.8,325Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M132,329.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C132.8,329.8,132.5,329.4,132,329.1Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M139.2,333.2l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C139.9,333.9,139.6,333.5,139.2,333.2Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M146.3,337.3l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C147,338,146.8,337.6,146.3,337.3Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M148,346.3a3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7A2.8,2.8,0,0,0,148,346.3Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M155.2,350.4a3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7A2.4,2.4,0,0,0,155.2,350.4Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M157.8,352.5l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A2,2,0,0,0,157.8,352.5Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M175,353.8l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C175.7,354.5,175.4,354.1,175,353.8Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M63.8,307.9l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.6,1.6,0,0,0,63.8,307.9Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M74.6,307.6l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7A3.6,3.6,0,0,0,74.6,307.6Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M88.7,314.5a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2A1.4,1.4,0,0,0,88.7,314.5Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M85.2,320.3l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A2,2,0,0,0,85.2,320.3Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M92.4,324.4l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.4,1.4,0,0,0,92.4,324.4Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M99.6,328.5l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.3,1.3,0,0,0,99.6,328.5Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M106.7,332.6l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.4,1.4,0,0,0,106.7,332.6Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M113.9,336.8l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.6,1.6,0,0,0,113.9,336.8Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M121,340.9l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A2,2,0,0,0,121,340.9Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M128.1,345l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A2,2,0,0,0,128.1,345Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M135.3,349.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.5,1.5,0,0,0,135.3,349.1Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M153.1,351.5a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2A1.2,1.2,0,0,0,153.1,351.5Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M166.7,358.7l-10.2-5.9a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l10.2,5.9a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3C167.4,359.3,167.2,359,166.7,358.7Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M55.2,312.8l10.1,5.8a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-10.1-5.8a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.6,1.6,0,0,0,55.2,312.8Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M68.8,319.9a1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2A2.1,2.1,0,0,0,68.8,319.9Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M76.6,325.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.5,1.5,0,0,0,76.6,325.1Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M83.8,329.2l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2A1.5,1.5,0,0,0,83,328,1.4,1.4,0,0,0,83.8,329.2Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M91,333.4l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.6,1.6,0,0,0,91,333.4Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M98.1,337.5l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.6,1.6,0,0,0,98.1,337.5Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M105.3,341.6l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.4,1.4,0,0,0,105.3,341.6Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M112.4,345.7l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.5,1.5,0,0,0,112.4,345.7Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M119.6,349.8l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.2,1.2,0,0,0,119.6,349.8Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M126.8,354l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.4,1.4,0,0,0,126.8,354Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M133.9,358.1l10.1,5.8a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2a1.5,1.5,0,0,0,.9-1.3,1.5,1.5,0,0,0-.7-1.1l-10.1-5.8a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3A1.6,1.6,0,0,0,133.9,358.1Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M158.1,363.6l-3-1.7a3.8,3.8,0,0,0-3.3.1L140,368.8a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l11.8-6.8a1.5,1.5,0,0,0,.9-1.3C158.9,364.2,158.6,363.8,158.1,363.6Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M57.5,315.9a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2C57.2,316.8,57.5,316.4,57.5,315.9Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M64.6,320a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2A1.2,1.2,0,0,0,64.6,320Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M71.8,324.1a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2A1.2,1.2,0,0,0,71.8,324.1Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M79,328.2a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2A1.4,1.4,0,0,0,79,328.2Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M107.6,344.7a1.5,1.5,0,0,0-.7-1.1L82.4,329.5a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l24.5,14.1a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2A1.2,1.2,0,0,0,107.6,344.7Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M114.7,348.9a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2A1.4,1.4,0,0,0,114.7,348.9Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M121.9,353a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2C121.5,353.9,121.9,353.5,121.9,353Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M129.1,357.1a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2A1.4,1.4,0,0,0,129.1,357.1Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M136.2,361.2a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2A1.2,1.2,0,0,0,136.2,361.2Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="a"
              d="M143.3,365.3a1.5,1.5,0,0,0-.7-1.1l-3-1.7a3.8,3.8,0,0,0-3.3.1l-3.5,2a1.5,1.5,0,0,0-.9,1.3,1.5,1.5,0,0,0,.7,1.1l3,1.7a3.2,3.2,0,0,0,1.4.3,3.7,3.7,0,0,0,1.8-.5l3.5-2A1.2,1.2,0,0,0,143.3,365.3Z"
              transform="translate(-0.1 -0.3)"
            />
          </g>
          <g>
            <g>
              <path
                class="b"
                d="M83.3,298.4l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.1,3.1,0,0,1,83.3,298.4Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M84.5,299.1a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A4.3,4.3,0,0,1,84.5,299.1Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l1.2-.7c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5l.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M90.4,302.5l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.1,3.1,0,0,1,90.4,302.5Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M91.6,303.2a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A4.1,4.1,0,0,1,91.6,303.2Zm-1-1.1A2.9,2.9,0,0,0,93,302l1.2-.7c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M97.6,306.6,94.7,305c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.1,3.1,0,0,1,97.6,306.6Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M98.8,307.3a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A4.3,4.3,0,0,1,98.8,307.3Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l1.2-.7c.3-.2.5-.4.5-.5l-.3-.3L98.7,303a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M104.7,310.7l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.1,3.1,0,0,1,104.7,310.7Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M105.9,311.5a2.9,2.9,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A6.5,6.5,0,0,1,105.9,311.5Zm-1.1-4.7a3.2,3.2,0,0,0-1.4.3l-1.2.7c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l2.9,1.6a2.9,2.9,0,0,0,2.4-.1l1.2-.7c.3-.2.5-.4.5-.5l-.3-.3-2.9-1.6Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M111.8,314.8l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.1,3.1,0,0,1,111.8,314.8Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M113,315.6a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A5.8,5.8,0,0,1,113,315.6Zm-1-1.2a2.9,2.9,0,0,0,2.4-.1l1.2-.7.5-.5a.5.5,0,0,0-.3-.3l-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M118.9,318.9l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A2.8,2.8,0,0,1,118.9,318.9Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M120.2,319.7a3.2,3.2,0,0,1-1.4-.3l-2.9-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A4.9,4.9,0,0,1,120.2,319.7Zm-1-1.2a2.9,2.9,0,0,0,2.4-.1l1.2-.7c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5l.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M126.1,323l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A2.8,2.8,0,0,1,126.1,323Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M127.3,323.8a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A6.5,6.5,0,0,1,127.3,323.8Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l1.2-.7c.3-.2.5-.4.5-.5l-.3-.3-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M133.2,327.1l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A2.8,2.8,0,0,1,133.2,327.1Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M134.4,327.9a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A6.5,6.5,0,0,1,134.4,327.9Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l1.2-.7c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7-.5.5a.5.5,0,0,0,.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M140.3,331.3l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.4,3.4,0,0,1,140.3,331.3Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M141.5,332a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A5.8,5.8,0,0,1,141.5,332Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l1.2-.7.5-.5a.5.5,0,0,0-.3-.3l-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M147.5,335.4l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.4,3.4,0,0,1,147.5,335.4Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M148.7,336.1a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A6.5,6.5,0,0,1,148.7,336.1Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l1.2-.7c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M154.8,339.6l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.1,3.1,0,0,1,154.8,339.6Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M156,340.3a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A4.3,4.3,0,0,1,156,340.3Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l1.2-.7c.3-.2.5-.4.5-.5l-.3-.3-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M161.9,343.7l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.1,3.1,0,0,1,161.9,343.7Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M163.1,344.4a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A4.1,4.1,0,0,1,163.1,344.4Zm-1.1-4.6a3.2,3.2,0,0,0-1.4.3l-1.2.7c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l2.9,1.6a2.9,2.9,0,0,0,2.4-.1l1.2-.7c.3-.2.5-.4.5-.5l-.3-.3L163,340Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M169.1,347.8l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.1,3.1,0,0,1,169.1,347.8Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M170.3,348.5a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A4.3,4.3,0,0,1,170.3,348.5Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l1.2-.7.5-.5a.5.5,0,0,0-.3-.3l-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <path
                class="b"
                d="M176.2,351.9l-2.9-1.6c-.7-.4-.6-1.1.2-1.6l1.2-.7a3.1,3.1,0,0,1,2.8-.1l2.9,1.6c.7.4.6,1.1-.2,1.6l-1.2.7A3.1,3.1,0,0,1,176.2,351.9Z"
                transform="translate(-0.1 -0.3)"
              />
              <path
                class="a"
                d="M177.4,352.6a3.2,3.2,0,0,1-1.4-.3l-2.9-1.6a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l1.2-.7a3.5,3.5,0,0,1,3.3-.1l2.9,1.6a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-1.2.7A4.3,4.3,0,0,1,177.4,352.6Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l1.2-.7c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-2.9-1.6a2.9,2.9,0,0,0-2.4.1l-1.2.7c-.3.2-.5.4-.5.5l.3.3Z"
                transform="translate(-0.1 -0.3)"
              />
            </g>
            <g>
              <g>
                <path
                  class="b"
                  d="M75.1,303.2l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,75.1,303.2Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M76.3,304a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A5.8,5.8,0,0,1,76.3,304Zm1.1-6.1a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2,.5-.5a.5.5,0,0,0-.3-.3l-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M82.2,307.3l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A2.8,2.8,0,0,1,82.2,307.3Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M83.4,308.1a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A5.8,5.8,0,0,1,83.4,308.1Zm-.9-1.2a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M89.4,311.5l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,89.4,311.5Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M90.7,312.2a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.6,4.6,0,0,1,90.7,312.2Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M96.6,315.6l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,96.6,315.6Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M97.8,316.3a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,97.8,316.3Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2,.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M103.7,319.7l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,103.7,319.7Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M104.9,320.4a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,104.9,320.4Zm1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2,.5-.5a.5.5,0,0,0-.3-.3l-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M110.9,323.8l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A2.8,2.8,0,0,1,110.9,323.8Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M112.1,324.6a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,112.1,324.6Zm1-6.1a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M118,328l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,118,328Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M119.2,328.7a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A5.8,5.8,0,0,1,119.2,328.7Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M125.2,332.1l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,125.2,332.1Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M126.4,332.8a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.1,4.1,0,0,1,126.4,332.8Zm1.1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5l.3.3,3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M132.3,336.2l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,132.3,336.2Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M133.6,336.9a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,133.6,336.9Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M139.5,340.3l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,139.5,340.3Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M140.7,341a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,140.7,341Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M146.7,344.5l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,146.7,344.5Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M147.9,345.2a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,147.9,345.2Zm1-6.1a3.2,3.2,0,0,0-1.4.3l-3.5,2-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M153.8,348.6l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,153.8,348.6Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M155,349.3a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A5.8,5.8,0,0,1,155,349.3Zm1.1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5l.3.3,3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7A1.8,1.8,0,0,0,156.1,343.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M160.9,352.7l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,160.9,352.7Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M162.2,353.4a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A7.2,7.2,0,0,1,162.2,353.4Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M168.1,356.8l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,168.1,356.8Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M169.4,357.5a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.6,4.6,0,0,1,169.4,357.5Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  class="b"
                  d="M66.9,308.1l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,66.9,308.1Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M68.1,308.8a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,68.1,308.8Zm1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5l.3.3,3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M74,312.2l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,74,312.2Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M75.2,312.9a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.1,4.1,0,0,1,75.2,312.9Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M81.2,316.4l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,81.2,316.4Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M82.4,317.1a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A5.8,5.8,0,0,1,82.4,317.1Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5l-.3-.3-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M88.3,320.5l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,88.3,320.5Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M89.6,321.2a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A7.2,7.2,0,0,1,89.6,321.2Zm1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5l-.3-.3-3-1.7A1.6,1.6,0,0,0,90.6,315.2Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M95.5,324.6l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,95.5,324.6Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M96.7,325.3a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,96.7,325.3Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2,.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M102.7,328.7l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,102.7,328.7Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M103.9,329.4a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,103.9,329.4Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M109.8,332.8l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,109.8,332.8Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M111,333.6a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,111,333.6Zm-1-1.2a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M117,337l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,117,337Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M118.2,337.7a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,118.2,337.7Zm1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5l-.3-.3-3-1.7A1.5,1.5,0,0,0,119.2,331.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M124.1,341.1l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,124.1,341.1Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M125.3,341.8a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A5.8,5.8,0,0,1,125.3,341.8Zm1.1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5l.3.3,3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7A1.6,1.6,0,0,0,126.4,335.8Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M131.3,345.2l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,131.3,345.2Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M132.5,345.9a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,132.5,345.9Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M138.5,349.3l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,138.5,349.3Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M139.7,350.1a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,139.7,350.1Zm-1-1.2a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M145.6,353.4l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A2.8,2.8,0,0,1,145.6,353.4Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M146.8,354.2a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,146.8,354.2Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M159.9,361.7l-10.2-5.9c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l10.2,5.9c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,159.9,361.7Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M161.1,362.4a3.2,3.2,0,0,1-1.4-.3l-10.2-5.9a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l10.2,5.9a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.1,4.1,0,0,1,161.1,362.4ZM155,352.2a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l10.2,5.9a2.9,2.9,0,0,0,2.4-.1l3.5-2,.5-.5a.5.5,0,0,0-.3-.3L156,352.4Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  class="b"
                  d="M65.3,317l-10.1-5.8c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l10.1,5.8c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,65.3,317Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M66.6,317.8a3.2,3.2,0,0,1-1.4-.3l-10.1-5.8a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1L72.2,313a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A7.2,7.2,0,0,1,66.6,317.8Zm-1-1.2a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-10.1-5.8a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M72.6,321.2l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,72.6,321.2Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M73.8,321.9a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.1,4.1,0,0,1,73.8,321.9Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M79.7,325.3l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,79.7,325.3Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M81,326.1a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A7.2,7.2,0,0,1,81,326.1Zm1-6.1a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M86.9,329.4l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,86.9,329.4Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M88.1,330.2a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,88.1,330.2Zm-1-1.2a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5l-.3-.3-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M94.1,333.6l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,94.1,333.6Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M95.3,334.3a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,95.3,334.3Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2,.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M101.2,337.7l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,101.2,337.7Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M102.4,338.4a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,102.4,338.4Zm1.1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2,.5-.5a.5.5,0,0,0-.3-.3l-3-1.7A1.8,1.8,0,0,0,103.5,332.4Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M108.4,341.8l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,108.4,341.8Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M109.6,342.6a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,109.6,342.6Zm1.1-6.1a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M115.5,345.9l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A2.8,2.8,0,0,1,115.5,345.9Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M116.7,346.7a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A5.8,5.8,0,0,1,116.7,346.7Zm-.9-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5l.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M122.7,350l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A2.8,2.8,0,0,1,122.7,350Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M123.9,350.8a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,123.9,350.8Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2,.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M129.9,354.2l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,129.9,354.2Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M131.1,354.9a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,131.1,354.9Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M144.2,362.5l-10.3-6c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l10.3,6c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,144.2,362.5Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M145.5,363.3a3.2,3.2,0,0,1-1.4-.3l-10.3-6a1.2,1.2,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l10.3,6a1.2,1.2,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A7.2,7.2,0,0,1,145.5,363.3Zm-1-1.2a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-10.3-6a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M143,371.4l-3-1.7c-.7-.4-.6-1.1.2-1.6l11.8-6.8a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-11.8,6.8A3.4,3.4,0,0,1,143,371.4Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M144.2,372.1a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l11.8-6.8a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-11.8,6.8A6.5,6.5,0,0,1,144.2,372.1Zm9.4-10.9a3.2,3.2,0,0,0-1.4.3l-11.8,6.8c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l11.8-6.8c.3-.2.5-.4.5-.5l-.3-.3-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  class="b"
                  d="M50,317.8l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,50,317.8Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M51.2,318.5a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,51.2,318.5Zm1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7A1.6,1.6,0,0,0,52.2,312.5Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M57.1,321.9l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,57.1,321.9Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M58.3,322.6a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,58.3,322.6Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5l-.3-.3-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M64.3,326l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A2.8,2.8,0,0,1,64.3,326Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M65.5,326.8a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,65.5,326.8Zm-1-1.2a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5l.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M71.4,330.1l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A2.8,2.8,0,0,1,71.4,330.1Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M72.6,330.9a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A5.8,5.8,0,0,1,72.6,330.9Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M100.1,346.7,75.6,332.6c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1L106.6,343c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,100.1,346.7Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M101.3,347.4a3.2,3.2,0,0,1-1.4-.3L75.4,333a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l24.5,14.1a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,101.3,347.4Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3L81.9,329.3a2.9,2.9,0,0,0-2.4.1l-3.5,2-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M107.2,350.8l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,107.2,350.8Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M108.4,351.5a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A5.8,5.8,0,0,1,108.4,351.5Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M114.3,354.9l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.4,3.4,0,0,1,114.3,354.9Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M115.6,355.6a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A7.2,7.2,0,0,1,115.6,355.6Zm1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7A1.6,1.6,0,0,0,116.6,349.6Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M121.5,359l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,121.5,359Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M122.8,359.7a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.6,4.6,0,0,1,122.8,359.7Zm1-6a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2c.3-.2.5-.4.5-.5a.5.5,0,0,0-.3-.3l-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M128.7,363.1l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,128.7,363.1Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M129.9,363.8a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A4.3,4.3,0,0,1,129.9,363.8Zm-1-1.1a2.9,2.9,0,0,0,2.4-.1l3.5-2,.5-.5a.5.5,0,0,0-.3-.3l-3-1.7a2.9,2.9,0,0,0-2.4.1l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
              <g>
                <path
                  class="b"
                  d="M135.8,367.2l-3-1.7c-.7-.4-.6-1.1.2-1.6l3.5-2a3.1,3.1,0,0,1,2.8-.1l3,1.7c.7.4.6,1.1-.2,1.6l-3.5,2A3.1,3.1,0,0,1,135.8,367.2Z"
                  transform="translate(-0.1 -0.3)"
                />
                <path
                  class="a"
                  d="M137,368a3.2,3.2,0,0,1-1.4-.3l-3-1.7a1.3,1.3,0,0,1-.7-1.1,1.5,1.5,0,0,1,.9-1.3l3.5-2a3.5,3.5,0,0,1,3.3-.1l3,1.7a1.3,1.3,0,0,1,.7,1.1,1.5,1.5,0,0,1-.9,1.3l-3.5,2A6.5,6.5,0,0,1,137,368Zm1-6.1a3.2,3.2,0,0,0-1.4.3l-3.5,2c-.3.2-.5.4-.5.5a.5.5,0,0,0,.3.3l3,1.7a2.9,2.9,0,0,0,2.4-.1l3.5-2,.5-.5a.5.5,0,0,0-.3-.3l-3-1.7Z"
                  transform="translate(-0.1 -0.3)"
                />
              </g>
            </g>
          </g>
          <path
            class="a"
            d="M114.5,397.1a7.2,7.2,0,0,1-3.7-.9L3.7,334.6a2.9,2.9,0,0,1-1.6-2.4,3.7,3.7,0,0,1,2.2-3L81,284.8c2.6-1.5,6.3-1.6,8.5-.3l107.1,61.7a2.9,2.9,0,0,1,1.6,2.4,3.7,3.7,0,0,1-2.2,3L119.3,396A10.9,10.9,0,0,1,114.5,397.1ZM85.7,284.4a9.6,9.6,0,0,0-4.4,1.1L4.6,329.9a3,3,0,0,0-1.8,2.3A1.9,1.9,0,0,0,4,333.8l107.1,61.7a8.5,8.5,0,0,0,7.6-.3l76.7-44.4a3,3,0,0,0,1.8-2.3,1.9,1.9,0,0,0-1.2-1.6L88.9,285.2A6.1,6.1,0,0,0,85.7,284.4Z"
            transform="translate(-0.1 -0.3)"
          />
        </g>
        <path
          class="a"
          d="M176.3,249.2v1.4l8.7,5-1.7.9.8,1.5,2.7-1.3,2.5,1.4v.2l-6,3,.8,1.5,5.2-2.6v2.9l-6,3,.8,1.5,5.2-2.6v2.8l-6,3,.8,1.5,5.2-2.6v2.9l-6,3,.8,1.5,5.2-2.6v2.9l-6,3,.8,1.5,5.2-2.6v2.9l-6,3,.8,1.5,5.2-2.6v2.8l-6,3,.8,1.5,5.2-2.6v2.9l-6,3,.8,1.5,5.2-2.6v2.8l-5.9,3,.8,1.5,5.1-2.5v2.9l-5.9,3,.8,1.5,5.1-2.5v2.8l-5.9,3,.8,1.5,5.1-2.5V311l-5.9,3,.8,1.5,5.1-2.5v2.9l-5.9,3,.8,1.5,5.1-2.5v2.9l-3.4,1.7-39.4-22.7v1.4l44.1,25.4V257.4Zm11.4,74.3,1.6-.8v1.7Z"
          transform="translate(-0.1 -0.3)"
        />
      </g>
      <g>
        <path
          class="a"
          d="M55.2,373.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,55.2,373.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M59,371.4a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,59,371.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M51.4,371.4a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,51.4,371.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M55.2,369.2a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,55.2,369.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M47.6,369.2a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,47.6,369.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M51.4,367a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,51.4,367Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M43.8,367a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,43.8,367Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M47.6,364.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,47.6,364.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M40,364.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,40,364.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M43.8,362.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,43.8,362.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M36.2,362.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,36.2,362.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M40,360.4a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,40,360.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M32.4,360.4a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,32.4,360.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M36.2,358.2a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,36.2,358.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M28.6,358.2a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,28.6,358.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M32.4,356a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,32.4,356Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M24.8,356a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,24.8,356Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M28.6,353.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,28.6,353.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M21,353.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,21,353.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M24.8,351.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,24.8,351.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M17.2,351.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,17.2,351.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M21,349.4a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,21,349.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M13.4,349.4a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,13.4,349.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M17.2,347.2a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,17.2,347.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M9.6,347.2a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,9.6,347.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M13.4,345a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,13.4,345Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M5,346c.6,0,1-.2,1-.6s-.4-.6-1-.6-1,.3-1,.6S4.5,346,5,346Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M9.5,342.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,9.5,342.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M1.9,342.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,1.9,342.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M5.7,340.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,5.7,340.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M1.2,339.4c.6,0,1-.2,1-.6s-.4-.6-1-.6-1,.3-1,.6S.7,339.4,1.2,339.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M123.9,408.4a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,123.9,408.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M127.7,406.2a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,127.7,406.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M131.5,404a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,131.5,404Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M135.3,401.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,135.3,401.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M139.1,399.7a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,139.1,399.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M142.9,397.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,142.9,397.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M146.7,395.3a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,146.7,395.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M150.5,393.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,150.5,393.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M154.3,390.9a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,154.3,390.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M158.1,388.7a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,158.1,388.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M162,386.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,162,386.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M165.8,384.3a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,165.8,384.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M169.6,382.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,169.6,382.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M173.4,379.9a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,173.4,379.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M177.2,377.7a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,177.2,377.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M116.3,408.4a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,116.3,408.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M120.1,406.2a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,120.1,406.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M123.9,404a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,123.9,404Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M127.7,401.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,127.7,401.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M131.5,399.7a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,131.5,399.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M135.3,397.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,135.3,397.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M138.4,396.3c.6,0,1-.2,1-.6s-.4-.6-1-.6-1,.3-1,.6S137.9,396.3,138.4,396.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M142.9,393.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,142.9,393.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M146.7,390.9a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,146.7,390.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M150.5,388.7a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,150.5,388.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M154.3,386.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,154.3,386.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M158.1,384.3a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,158.1,384.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M162,382.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,162,382.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M165,380.9c.6,0,1-.2,1-.6s-.4-.6-1-.6-1,.3-1,.6S164.5,380.9,165,380.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M169.6,377.7a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,169.6,377.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M173.4,375.5a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,173.4,375.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M112.5,406.2a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,112.5,406.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M116.3,404a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,116.3,404Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M120.1,401.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,120.1,401.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M123.9,399.7a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,123.9,399.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M127,398.5c.6,0,1-.2,1-.6s-.4-.6-1-.6-1,.3-1,.6S126.5,398.5,127,398.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M131.5,395.3a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,131.5,395.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M135.3,393.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,135.3,393.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M139.1,390.9a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,139.1,390.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M142.9,388.7a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,142.9,388.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M146.7,386.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,146.7,386.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M150.5,384.3a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,150.5,384.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M154.3,382.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,154.3,382.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M158.1,379.9a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,158.1,379.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M162,377.7a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,162,377.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M165.8,375.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,165.8,375.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M169.6,373.3a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,169.6,373.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M108.7,404a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,108.7,404Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M112.5,401.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,112.5,401.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M104.9,401.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,104.9,401.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M108.7,399.7a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,108.7,399.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M101.1,399.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,101.1,399.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M104.9,397.4a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,104.9,397.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M97.3,397.4a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,97.3,397.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M101.1,395.2a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,101.1,395.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M93.5,395.2a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,93.5,395.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M97.3,393a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,97.3,393Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M89.7,393a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,89.7,393Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M93.5,390.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,93.5,390.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M85.8,390.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,85.8,390.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M89.7,388.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,89.7,388.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M82,388.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,82,388.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M85.8,386.5a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,85.8,386.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M78.2,386.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,78.2,386.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M82,384.3a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,82,384.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M74.4,384.3a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,74.4,384.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M78.2,382.1a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,78.2,382.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M70.6,382a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,70.6,382Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M74.4,379.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,74.4,379.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M66.8,379.8a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,66.8,379.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M70.6,377.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,70.6,377.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M63,377.6a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,63,377.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M66.8,375.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,66.8,375.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M59.2,375.5a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,59.2,375.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M63,373.3a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,63,373.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M181,375.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A2,2,0,0,1,181,375.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M184.8,373.3a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,184.8,373.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M188.6,371.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,188.6,371.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M192.4,368.9a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,192.4,368.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M196.2,366.7a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,196.2,366.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M200,364.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,200,364.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M203.8,362.3a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,203.8,362.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M207.6,360.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,207.6,360.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M175.7,373.3a1.9,1.9,0,0,1,1.5,0,.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0C175.3,373.9,175.3,373.6,175.7,373.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M181,371.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,181,371.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M184.8,368.9a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,184.8,368.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M188.6,366.7a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,188.6,366.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M192.4,364.5a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,192.4,364.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M196.2,362.3a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,196.2,362.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M200,360.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,200,360.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M203.8,357.9a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,203.8,357.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M207.6,355.8a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,207.6,355.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M171.9,371.1a1.9,1.9,0,0,1,1.5,0,.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0C171.5,371.7,171.5,371.4,171.9,371.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M177.2,368.9a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,177.2,368.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M181,366.7a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,181,366.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M184.8,364.5a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,184.8,364.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M188.6,362.3a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,188.6,362.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M192.4,360.1a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,192.4,360.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M196.2,357.9a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.9,1.9,0,0,1,196.2,357.9Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M200,355.8a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,200,355.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M203.1,354.6c.6,0,1-.2,1-.6s-.4-.6-1-.6-1,.3-1,.6S202.6,354.6,203.1,354.6Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M207.6,351.4a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,207.6,351.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M200,351.4a.4.4,0,0,1,0,.8,2,2,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,200,351.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M203.8,349.2a.4.4,0,0,1,0,.8,1.9,1.9,0,0,1-1.5,0,.4.4,0,0,1,0-.8A1.4,1.4,0,0,1,203.8,349.2Z"
          transform="translate(-0.1 -0.3)"
        />
      </g>
    </g>
    <g id="jet" class="all-rocket">
      <g class="burst">
        <path
          class="c"
          d="M156.5,279a9.4,9.4,0,0,1,17.6-6.4,9.4,9.4,0,1,1-17.6,6.4Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M166.2,266.2a7.8,7.8,0,0,0-4.7.5,9.1,9.1,0,0,0-5.8,11.2,7.8,7.8,0,0,0,4.7-.5A9.3,9.3,0,0,0,166.2,266.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M161.8,266.2a10.1,10.1,0,1,1-6.1,12.9A10.2,10.2,0,0,1,161.8,266.2Zm6.5,17.6a8.6,8.6,0,1,0-11.1-5.1A8.6,8.6,0,0,0,168.3,283.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="d"
          d="M153.1,305.3a18.8,18.8,0,0,0-9.4-10.4,19.9,19.9,0,0,0-9.6-1.6,23.2,23.2,0,0,0-1.2-5.7,25.4,25.4,0,0,0-2.9-5.4,22.5,22.5,0,0,0,1.4-4.4h.1a14.2,14.2,0,0,0,4.1-.8,12,12,0,0,0-8-22.7,12.9,12.9,0,0,0-5,3.5,13.8,13.8,0,0,0-.9-5.3,3.1,3.1,0,0,1-.5-1h1.2a9.5,9.5,0,0,0,3.8-.7,11.4,11.4,0,0,0,6.9-14.5,12.1,12.1,0,0,0-6-6.6,10.7,10.7,0,0,0-8.6-.4,10.4,10.4,0,0,0-5.5,4.2,9,9,0,0,0-3.4-3,8.1,8.1,0,0,0-6.3-.3,8.4,8.4,0,0,0-5.1,10.6,8.9,8.9,0,0,0,2.3,3.4,14.6,14.6,0,0,0-7.7,11.5,2.9,2.9,0,0,1-1.1.3,10.1,10.1,0,0,0-6.1,12.9,9.8,9.8,0,0,0,9.4,6.7,7.6,7.6,0,0,0,3.4-.6l.8-.3a10.9,10.9,0,0,0,.1,1.8,24.3,24.3,0,0,0-3.8,3.4,11.8,11.8,0,0,0-12.8-3.4,12,12,0,0,0-7.6,13.1l-1.5.5a19.5,19.5,0,0,0-11.7,24.7,18.9,18.9,0,0,0,9.9,11,19.2,19.2,0,0,0,8.2,1.8,18.7,18.7,0,0,0,6.5-1.2c.2,0,.2-.2.3-.2a23.9,23.9,0,0,0,1.3,8.7,22,22,0,0,0,11.5,12.8,24.2,24.2,0,0,0,9.4,2.1,19.7,19.7,0,0,0,7.6-1.4,22.2,22.2,0,0,0,14.8-19.6,18.4,18.4,0,0,0,4.1.5,16.1,16.1,0,0,0,6.1-1.1A17.5,17.5,0,0,0,153.1,305.3Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M112.8,285.8a15.6,15.6,0,0,0-15.5-15.5,16.9,16.9,0,0,0-8.8,2.7,10.1,10.1,0,0,0,2.7,1.9,10.7,10.7,0,0,0,4.3.9,8.8,8.8,0,0,0,3.3-.6l.8-.3a5.5,5.5,0,0,0,.2,1.8A23.7,23.7,0,0,0,96,280a14.8,14.8,0,0,0-3.8-2.9,12,12,0,0,0-7-.9,14.8,14.8,0,0,0-3.4,9.6,15.5,15.5,0,0,0,31,0Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M131.5,257.8a15.3,15.3,0,0,0-.7-4.1,24.4,24.4,0,0,0-3.1.6,14.6,14.6,0,0,0-5,3.5,12.1,12.1,0,0,0-.9-5.3,9.3,9.3,0,0,0-.5-1h1.3a10.2,10.2,0,0,0,3.8-.7,3.9,3.9,0,0,0,1.6-.7,10.6,10.6,0,1,0,3.5,7.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="c"
          d="M121.3,299.2a19.8,19.8,0,0,0,0,39.5,20.8,20.8,0,0,0,8.9-2.1,23.5,23.5,0,0,0,1.8-7.5,19.2,19.2,0,0,0,4.1.5,6.8,6.8,0,0,0,2-.2,19.9,19.9,0,0,0,3-10.6A19.7,19.7,0,0,0,121.3,299.2Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M109.6,350.7a21,21,0,0,1-9.7-2.3,21.9,21.9,0,0,1-11.8-13,21.6,21.6,0,0,1-1.4-7.9,21,21,0,0,1-6.1.9,18.3,18.3,0,0,1-8.5-2,20.2,20.2,0,0,1,1.7-37.1l.9-.3a12.5,12.5,0,0,1,8.2-13.2,12.7,12.7,0,0,1,9.4.4,13.7,13.7,0,0,1,3.7,2.6,25.5,25.5,0,0,1,3-2.6v-.4a10.9,10.9,0,0,1-8.1-.5,10.2,10.2,0,0,1-5.4-6.1A10.8,10.8,0,0,1,92,255.4h.6a15.8,15.8,0,0,1,7.2-11.1,14.4,14.4,0,0,1-1.9-3.1,9,9,0,0,1,5.5-11.5,8.7,8.7,0,0,1,6.9.3,9,9,0,0,1,3.1,2.4,10.9,10.9,0,0,1,5.2-3.6,12,12,0,0,1,9.3.4,11.8,11.8,0,0,1,6.2,6.8,12.2,12.2,0,0,1-7.3,15.6,15.4,15.4,0,0,1-4.2.7,23.5,23.5,0,0,1,.9,4,13.3,13.3,0,0,1,4.1-2.5,12.3,12.3,0,0,1,9.6.5,12.7,12.7,0,0,1-1.1,23.4,10.6,10.6,0,0,1-4,.8,16.9,16.9,0,0,1-1.2,3.6,20.8,20.8,0,0,1,2.8,5.3,23.1,23.1,0,0,1,1.2,5.2,17.1,17.1,0,0,1,9.2,1.7,18.3,18.3,0,0,1,9.8,10.8,18.8,18.8,0,0,1-11.4,24.1,19.6,19.6,0,0,1-9.9.8,23.5,23.5,0,0,1-15.1,19.5A23,23,0,0,1,109.6,350.7ZM88.2,325.5v1a23.8,23.8,0,0,0,1.2,8.4,21.7,21.7,0,0,0,11.1,12.3,20.8,20.8,0,0,0,16.4.8,21.8,21.8,0,0,0,14.3-19v-.8l.8.2a17.5,17.5,0,0,0,11.4-32.9,18.5,18.5,0,0,0-9.3-1.5l-.7.2v-.8a25.9,25.9,0,0,0-1.3-5.5,24.1,24.1,0,0,0-2.7-5.3l-.3-.3.2-.3a20.4,20.4,0,0,0,1.3-4.2l.2-.7h.7a9.5,9.5,0,0,0,3.8-.6,11.5,11.5,0,0,0,6.9-14.4,11.1,11.1,0,0,0-5.8-6.4,11.4,11.4,0,0,0-8.5-.4,11.7,11.7,0,0,0-4.7,3.1L122,260v-2a18.2,18.2,0,0,0-.8-5.2,1.6,1.6,0,0,1-.3-.9l-.5-1.1,1.3.2a11.2,11.2,0,0,0,4.8-.6,10.8,10.8,0,0,0,6.4-13.7,10.3,10.3,0,0,0-5.5-6.1,11.1,11.1,0,0,0-8.2-.4,10.4,10.4,0,0,0-5.1,3.9l-.7.9-.6-.9a6.6,6.6,0,0,0-3.2-2.7,7.5,7.5,0,0,0-10.3,9.4,9.9,9.9,0,0,0,2.1,3.2l.8.6-.9.5A13.5,13.5,0,0,0,94,256v.5h-.5a3.2,3.2,0,0,1-.9.3,9.4,9.4,0,0,0-.7,17.4,9.2,9.2,0,0,0,7.1.3l.8-.3,1-.5v1.1a5.5,5.5,0,0,0,.2,1.8v.4l-.3.3a23,23,0,0,0-3.7,3.2l-.6.6-.4-.6a10.7,10.7,0,0,0-3.7-2.7,11.4,11.4,0,0,0-8.3-.5,11.2,11.2,0,0,0-7.2,12.4l.2.6h-.6l-1.6.5a18.8,18.8,0,0,0-11.2,23.8,18.1,18.1,0,0,0,9.6,10.7,17.6,17.6,0,0,0,7.9,1.8,16.6,16.6,0,0,0,6.2-1.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="d"
          d="M107.8,326.7a20.1,20.1,0,1,1,20.1-20.1A20,20,0,0,1,107.8,326.7Zm0-38.6a18.6,18.6,0,1,0,18.6,18.5A18.5,18.5,0,0,0,107.8,288.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M77.3,243.7a13.1,13.1,0,0,0,4.1-4.9,12.8,12.8,0,0,0-5-16.5,13.9,13.9,0,0,0-4.2,4.8A13,13,0,0,0,77.3,243.7Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M134.6,353.8A14.8,14.8,0,1,0,118.1,341,14.8,14.8,0,0,0,134.6,353.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="d"
          d="M135.9,328.5a13.9,13.9,0,0,1-13.8,13.9,5.5,5.5,0,0,1-1.8-.2c0,.6.1,1.1.1,1.7H122a15.6,15.6,0,0,0,15.5-15.5,4.4,4.4,0,0,0-.2-1.6,5,5,0,0,0-1.7-.2A3.8,3.8,0,0,1,135.9,328.5Z"
          transform="translate(-0.1 -0.3)"
        />
      </g>
      <g class="fire">
        <path
          class="c"
          d="M117.9,208.8a3.1,3.1,0,0,0-4.4.3c-2.9,3.1-8.3,9.9-8.9,19.7s4.4,20.3,8.2,24.2c1.5,1.5,4.1,2.1,5.6.7,4.1-3.8,9.1-12.6,9.4-22A28.9,28.9,0,0,0,117.9,208.8Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M117.8,255.4a5.8,5.8,0,0,1-5.7-1.5c-4-4-8.9-14.9-8.5-24.9a33.3,33.3,0,0,1,9.1-20.3,4.3,4.3,0,0,1,5.8-.3c7.1,6.1,10.5,14,10.3,23.7s-5.1,18.4-9.8,22.8C118.6,254.9,118.1,255.3,117.8,255.4Zm-2.9-46.3c-.3.2-.7.3-.8.6a30.3,30.3,0,0,0-8.5,19.2c-.5,9.4,4.3,19.7,7.9,23.4,1.3,1.2,3.2,1.9,4.2.9,3.5-3.2,8.9-11.8,9.1-21.5a26.9,26.9,0,0,0-9.7-22.2A2.7,2.7,0,0,0,114.9,209.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="d"
          d="M118.2,216.5a1.9,1.9,0,0,0-2.5.1,16.8,16.8,0,0,0-4.6,10.4c-.3,5.2,2.2,10.6,4.2,12.7a2.2,2.2,0,0,0,3.1.5,18.2,18.2,0,0,0,5-11.5A14.7,14.7,0,0,0,118.2,216.5Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M116.1,238.6a3.6,3.6,0,0,1-3.4-.9c-2.1-2.1-4.8-7.7-4.4-13.1a16.4,16.4,0,0,1,4.8-10.7,2.5,2.5,0,0,1,3.6-.1,15.6,15.6,0,0,1,5.4,12.5,19.6,19.6,0,0,1-5.1,12ZM114.7,215h-.4a15.9,15.9,0,0,0-4.3,9.6c-.3,4.7,2.1,9.9,3.8,11.7s1.3.7,1.6.4a17.2,17.2,0,0,0,4.6-10.7,13.2,13.2,0,0,0-4.9-11.1C115.2,214.8,115.1,214.8,114.7,215Z"
          transform="translate(-0.1 -0.3)"
        />
      </g>
      <g class="rocket">
        <g>
          <g>
            <path
              class="e"
              d="M144.1,227.6l-9.8-5.7L129,185.6l9.9,5.8Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="f"
              d="M138.9,191.4l-9.8-5.7c1.7-5.6,3.8-13.2,5.8-22.4,1.2-5.5,2.4-11.6,3.4-18.2l9.8,5.7c-1,6.6-2.2,12.6-3.4,18.2C142.7,178.2,140.6,185.8,138.9,191.4Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="f"
              d="M148.1,150.8l15.8,14.8L148.6,225l-4.5,2.6-5.3-36.2c1.7-5.6,3.8-13.1,5.8-22.4C145.9,163.4,147,157.4,148.1,150.8Z"
              transform="translate(-0.1 -0.3)"
            />
          </g>
          <path
            class="e"
            d="M90.1,211.7c-1.9-2.3-8.6-11.2-15.2-29.4,1.4,3.9,4.7,7.6,9.8,10.7,14.6,8.8,38.8,9,54,.5,5.8-3.2,9.4-7.2,10.9-11.5-1.1,3-1.9,5.2-3.1,8s-2.1,5-4,8.6a72.9,72.9,0,0,1-8,13,17.2,17.2,0,0,1-5.2,4.1c-9.8,5.5-25.4,5.3-34.8-.4A16.3,16.3,0,0,1,90.1,211.7Z"
            transform="translate(-0.1 -0.3)"
          />
          <path
            class="f"
            d="M79,42.9c1.3-2.5,3.1-5.7,4.5-8.1l2.4-4c1.9-2.9,2.5-3.9,4.7-6.9s2.5-3.3,4.5-5.8A86.6,86.6,0,0,1,103,9.5a50.4,50.4,0,0,1,4.6-4.1,28.4,28.4,0,0,1,4.1-3.1,34.4,34.4,0,0,1,4.1,3c1.9,1.5,3.3,2.9,4.6,4a113.9,113.9,0,0,1,7.9,8.5c2.6,3.2,3,3.7,4.5,5.7s3.1,4.3,4.7,6.8c3.5,5.4,6.6,11.2,7.2,12.4,3.5,6.9.5,14.6-9.1,20-13.6,7.6-35.3,7.4-48.4-.5C78.3,56.9,75.6,49.5,79,42.9Z"
            transform="translate(-0.1 -0.3)"
          />
          <path
            class="g"
            d="M74.8,182.2c-.9-2.5-1.7-4.8-2.7-7.9s-1.3-4.3-2.5-8.9c-2.2-8.6-3.5-16.9-3.6-17-.9-5.6-.9-5.8-1.6-11.4-.2-1.3-.5-5.2-.8-8.2-.8-11.3-.7-19.3-.7-21.4s.1-4.3.4-7.8S64,92,64,92c.3-2.6.7-5.1,1.1-7.3s.4-2.5.7-3.6,1-4.8,1.5-6.8,1.4-5.5,1.8-6.7c1.2-4.1,1.6-5.3,3.1-9.3a142.3,142.3,0,0,1,6-14c-3.3,6.7-.6,14.2,8.3,19.5,13.3,8,35.4,8.2,49.2.5,9.7-5.4,12.8-13.2,9.3-20.2,2,4,2.2,4.6,3.7,8,.5,1.1,1.7,4.1,2.3,5.8,1.5,4,1.9,5.2,3.1,9.2.4,1.2,1.3,4.5,1.9,6.7s1.1,4.7,1.6,6.8l.7,3.6c.4,2.2.8,4.7,1.1,7.3,0,0,.5,3.4.8,7.6s.4,5.9.4,7.8c.2,5.6-.1,13.7-.3,17.3s-.3,5.9-.6,8.4-.3,2.8-.4,4.1c-.5,4.2-.7,5.8-1,7.7-.7,4.7-1,6.4-1.8,10.8s-1.6,7.6-2.2,9.9-2.2,8.9-5.1,16.9c-1.5,4.2-5.2,8.2-11,11.5-15.2,8.5-39.4,8.2-54-.5C79.5,189.9,76.2,186.1,74.8,182.2Z"
            transform="translate(-0.1 -0.3)"
          />
          <path
            class="g"
            d="M78.4,44.1l.6-1.2c-3.3,6.6-.7,14,8.1,19.3,13.1,7.9,34.7,8.1,48.4.5,9.6-5.3,12.6-13.1,9.1-20l.6,1.2c3.6,7,.5,14.9-9.3,20.3-13.9,7.7-35.9,7.5-49.2-.5C77.7,58.4,75,50.9,78.4,44.1Z"
            transform="translate(-0.1 -0.3)"
          />
          <g>
            <path
              class="e"
              d="M87,260.6l-9.9-5.7L61.6,213.2l9.8,5.7Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="f"
              d="M71.4,218.9l-9.8-5.7,15.7-32.9,9.8,5.7Z"
              transform="translate(-0.1 -0.3)"
            />
            <path
              class="f"
              d="M87.1,186c1.1,5.4,2.3,10.1,3.5,14.2a111.8,111.8,0,0,0,5.9,15.7l-5,42.2L87,260.7,71.5,219.1Z"
              transform="translate(-0.1 -0.3)"
            />
          </g>
        </g>
        <path
          class="a"
          d="M125.6,108.2h-.1l1.2-6.9,5.3,5.3-5.5,2.4h-.1Zm7.7-.4,5.7,5.7c1.2,1.1,1.8,1.7,2,2.4a.4.4,0,0,0,.1.3l-13.6-5.7h0c-.1,0-.1,0-.1-.1h.1Zm7.5,10.3a11.8,11.8,0,0,1-1.8,2.1l-6.4,6.4-8.3-1.7h-.2a1.7,1.7,0,0,0-.3-1,1.6,1.6,0,0,0-.6-.8c-.1,0,0-.1,0-.1h0l1.5-9.7h0a.1.1,0,0,1,.1-.1l1-.4c.3-.1.5-.4.7-.6h.2l14.1,6Zm-9.7,10-10.5,10.6,1.8-11.2h.1a2.8,2.8,0,0,0,1.1-.8h.1l7.4,1.5Zm-12.7,12.8-1.2,1.2L104.1,123h.3l14.5,3h.2a3.7,3.7,0,0,0,.5,1.1l1,.7h0C120.4,128.7,118.8,138.3,118.4,140.9Zm-2.5,2.5a5.3,5.3,0,0,1-2,1.5,2.5,2.5,0,0,1-1.7,0c-.7-.2-1.3-.8-2.5-2L96.6,129.7l3.4-5.4h.2a3.3,3.3,0,0,0,2.4-.1h.1l13.2,19.2Zm-20.6-15-3-3,5.9-2.6h.1a.1.1,0,0,1,.1.1l.2.3h0l-3.3,5.1ZM90.9,124l-3.8-3.8-1.4-1.6,11.6,2.5h0c.1,0,.2,0,.2.1h-.2ZM85,116.7c0-.3.1-.5.1-.8a7.2,7.2,0,0,1,2-2.4l4.9-5,6.8,9.9s.1.1,0,.1l-.6.8h-.1L85,116.7Zm8.3-9.5,6.6-6.6,4.9,2.1,3.3,1.4a.1.1,0,0,1,.1.1h0a2.2,2.2,0,0,0,.1,1.4,2.4,2.4,0,0,0,.7,1.3h-.1l-6.7,10.4h-.1l-.8-.2h-.9l-7.1-10.4Zm7.9-7.9,8.5-8.6c1.2-1.2,1.8-1.8,2.5-2a2.5,2.5,0,0,1,1.7,0c.7.2,1.3.8,2.5,2l1.8,1.9-6,9.4H112a2.6,2.6,0,0,0-1.5-.1,3.1,3.1,0,0,0-1.3.6c-.1.1-.1,0-.2,0Zm18.3-5.4,5.6,5.6-1.3,8.4h-.1a2,2,0,0,0-.8.4h-.2l-8.5-3.7h-.1a2.9,2.9,0,0,0-.5-1.3c0-.1-.1-.2,0-.3Zm-5.7,12.6,8,3.4h.1a.6.6,0,0,0-.1.4v.2h-.1l-17.8,7.6h-.1a.1.1,0,0,1,.1-.1h0l6.6-10.2h.6a3.1,3.1,0,0,0,2.5-1.3h.2Zm-9.2,13.6,18-7.7h.1l.2.2h.1l-1.5,9.6h0c0,.1,0,.2-.1.2a2.7,2.7,0,0,0-1.2.3l-.8.9h-.2l-14.3-3Z"
          transform="translate(-0.1 -0.3)"
        />
      </g>
      <g class="top-burst">
        <path
          class="c"
          d="M70.6,231.1A12.8,12.8,0,1,1,53.4,237,12.9,12.9,0,0,1,70.6,231.1Z"
          transform="translate(-0.1 -0.3)"
        />
        <path
          class="a"
          d="M77.5,248.6a13.7,13.7,0,0,1-18.4,6.3,13.7,13.7,0,1,1,12-24.7A13.8,13.8,0,0,1,77.5,248.6ZM54.3,237.5A11.8,11.8,0,1,0,70.2,232,11.8,11.8,0,0,0,54.3,237.5Z"
          transform="translate(-0.1 -0.3)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { RoughEase } from "gsap/EasePack";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(RoughEase);
gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState([
      "toggleConfig",
      "startConfig",
      "isAnimationDisabled",
      "viewportSize",
    ]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    rocketAnim() {
      gsap.set(".rocket", {
        y: 120,
        scale: 0.4,
        opacity: 0.9,
        transformOrigin: "50% 50%",
      });
      gsap.set(".fire", {
        opacity: 1,
      });

      const tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: "#jet",
            toggleActions: this.toggleConfig,
            start: `center bottom`,
          },
          defaults: {
            duration: 1,
          },
        })
        .add("startjets")
        .to(
          ".rocket",
          {
            y: 110,
            opacity: 1,
            scale: 1,
            ease:
              "rough({ template: none.out, strength: 1, points: 20, taper: 'none', randomize: true, clamp: false})",
          },
          "startjets"
        )
        .to(
          ".rocket",
          {
            duration: 0.5,
            y: 0,
            ease: "back.out(1.7)",
          },
          "startjets+=0.8"
        )
        .fromTo(
          ".burst path, .top-burst path",
          {
            opacity: 0,
            scale: 0,
            transformOrigin: "50% 50%",
          },
          {
            opacity: 1,
            scale: 1,
            stagger: 0.05,
            ease: "back.out(1.7)",
          },
          "startjets+=0.65"
        )
        .fromTo(
          ".fire",
          {
            opacity: 0,
            scale: 0,
            transformOrigin: "50% 0%",
          },
          {
            opacity: 1,
            scale: 1,
            stagger: 0.05,
            ease: "elastic",
          },
          "startjets+=1"
        );

      return tl;
    },
  },
  mounted() {
    this.rocketAnim();
  },
};
</script>

<style lang="scss" scoped>
svg {
  width: 200px;
  height: 400px;
}

.a,
.e {
  fill: #0e1e25;
}

.b {
  fill: #ffbe2e;
}

.c,
.g {
  fill: #fff;
}

.d,
.f {
  fill: #ffad43;
}

.e,
.f,
.g {
  stroke: #0e1e25;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 4px;
}
</style>
